const getVisibleProducts = (prd_avl, history, urlParams) => {
  const validProducts = [
    "devices",
    "smartphone",
    "tablet",
    "laptop",
    "auto",
    "moto",
    "bike",
    "eBike",
    "scooter",
    "otro",
    "*",
    "gadgets",
  ];

  // Filtrar los productos válidos
  const filteredProducts = prd_avl.filter((product) =>
    validProducts.includes(product)
  );

  // Si hay productos no válidos, eliminarlos de la URL
  const invalidProducts = prd_avl.filter(
    (product) => !validProducts.includes(product)
  );
  if (invalidProducts.length > 0) {
    invalidProducts.forEach((invalidProduct) => {
      urlParams.delete("prd_avl", invalidProduct);
    });
    // Actualizar la URL eliminando los productos no válidos
    history.replace({ search: urlParams.toString() });
  }

  // Si no hay productos válidos o el array está vacío, reemplazamos con "*"
  if (filteredProducts.length === 0) {
    urlParams.set("prd_avl", "*");
    history.replace({ search: urlParams.toString() });
    return [
      "devices",
      "auto",
      "moto",
      "bike",
      "eBike",
      "scooter",
      "smartphone",
      "tablet",
      "laptop",
      "otro",
    ];
  }

  // Si "*" está presente, devolvemos todos los productos
  if (filteredProducts.includes("*")) {
    return [
      "devices",
      "auto",
      "moto",
      "bike",
      "eBike",
      "scooter",
      "smartphone",
      "tablet",
      "laptop",
      "otro",
    ];
  }

  let visibleProducts = [];
  if (filteredProducts.includes("moto")) visibleProducts.push("moto");
  if (filteredProducts.includes("auto")) visibleProducts.push("auto");
  if (filteredProducts.includes("bike")) visibleProducts.push("bike");
  if (filteredProducts.includes("eBike")) visibleProducts.push("eBike");
  if (filteredProducts.includes("scooter")) visibleProducts.push("scooter");
  if (filteredProducts.includes("otro")) visibleProducts.push("otro");
  if (filteredProducts.includes("gadgets")) visibleProducts.push("devices");
  if (filteredProducts.includes("devices")) visibleProducts.push("devices");
  if (filteredProducts.includes("smartphone")) visibleProducts.push("smartphone");
  if (filteredProducts.includes("tablet")) visibleProducts.push("tablet");
  if (filteredProducts.includes("laptop")) visibleProducts.push("laptop");

  // Si no se encuentran productos visibles, devolvemos todos los productos por defecto
  return visibleProducts.length > 0
    ? visibleProducts
    : [
        "devices",
        "auto",
        "moto",
        "bike",
        "eBike",
        "scooter",
        "smartphone",
        "tablet",
        "laptop",
        "otro",
      ];
};

export default getVisibleProducts;